import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import Input from 'Components/Input';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';
import { copyToClipboard } from 'Utils/copyToClipboard';
import { toast } from 'react-toastify';
import ToastTemplate from 'Components/ToastTemplate';

// combinations modal
export const CombinationsModal = props => {
  const { modalClose, modalData: { combinationsModal } } = props;

  return (
    <Modal
      title="Kombinasyonlar"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KAPAT',
          onClick: () => {
            modalClose();
          },
        }
      } }>
      <div className='combinations-modal'>
        { combinationsModal.combinations?.map((c, i) => (
          <div key={ i }>
            <div className='combinations-modal__content'>{ c.join(' / ') }</div>
          </div>
        )) }
      </div>
      <Message type="none"/>
    </Modal>
  );
};

CombinationsModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object,
  combinationsModal: PropTypes.object,
};


// coupon cancel modal
export const CouponCancelModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="Onay"
      iconName="svgInfoGreen"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'İPTAL ET',
          onClick: () => {
            onPrimaryClick();
          },
        },
        secondaryButton: {
          label: 'VAZGEÇ',
          onClick: () => {
            modalClose();
          },
        },
      } }>
      <Message type="none">
        <span>
         Kuponu iptal etmek istediğine emin misin?
        </span>
      </Message>
    </Modal>
  );
};

CouponCancelModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object,
  tjkCouponCancelModal: PropTypes.object
};

// coupon cancel failure modal
export const CouponCancelFailureModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="Kuponunuz İptal Edilemedi"
      type={ 'error' }
      iconName="svgInfoRed"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KUPONLARIMA GİT',
          onClick: () => {
            onPrimaryClick();
          },
        }
      } }>
      <Message type="none">
        <span>
         Kuponunuz iptal edilemedi.
        </span>
      </Message>
    </Modal>
  );
};

CouponCancelFailureModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon cancel failure modal
export const CouponCancelSuccessModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="İptal İşlemi Gerçekleştirildi"
      iconName="svgInfoGreen"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'PROGRAMA GİT',
          onClick: () => {
            onPrimaryClick();
          },
        }
      } }>
      <Message type="none">
        <span>
         Kuponunuz başarılı bir şekilde iptal edilmiştir.
        </span>
      </Message>
    </Modal>
  );
};

CouponCancelSuccessModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon delete modal
export const CouponDeleteModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="Onay"
      iconName="svgInfoGreen"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'SİL',
          onClick: () => {
            onPrimaryClick();
          },
        },
        secondaryButton: {
          label: 'VAZGEÇ',
          onClick: () => {
            modalClose();
          },
        },
      } }>
      <Message type="none">
        <span>
         Kuponu silmek istediğine emin misin?
        </span>
      </Message>
    </Modal>
  );
};

CouponDeleteModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object,
  tjkCouponDeleteModal: PropTypes.object
};

// coupon delete failure modal
export const CouponDeleteFailureModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="Kuponunuz Silinemedi"
      type={ 'error' }
      iconName="svgInfoRed"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KUPONLARIMA GİT',
          onClick: () => {
            onPrimaryClick();
          },
        }
      } }>
      <Message type="none">
        <span>
         Kuponunuz silinemedi.
        </span>
      </Message>
    </Modal>
  );
};

CouponDeleteFailureModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon delete success modal
export const CouponDeleteSuccessModal = props => {
  const { modalClose, onPrimaryClick } = props;

  return (
    <Modal
      title="Silme İşlemi Gerçekleştirildi"
      iconName="svgInfoGreen"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'PROGRAMA GİT',
          onClick: () => {
            onPrimaryClick();
          },
        }
      } }>
      <Message type="none">
        <span>
         Kuponunuz başarılı bir şekilde silinmiştir.
        </span>
      </Message>
    </Modal>
  );
};

CouponDeleteSuccessModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon detail failure modal
export const CouponDetailFailureModal = props => {
  const { modalClose } = props;

  return (
    <Modal
      title="Hata!"
      type={ 'error' }
      iconName="svgInfoRed"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KAPAT',
          onClick: () => {
            modalClose();
          },
        }
      } }>
      <Message type="none">
        <span>
         Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.
        </span>
      </Message>
    </Modal>
  );
};

CouponDetailFailureModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon rename modal
export const CouponRenameModal = props => {
  const { modalClose, onPrimaryClick } = props;
  const [name, setName] = useState('');

  return (
    <Modal
      title={ EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_coupon_saved_give_name' }) || 'Kuponuna İsim Ver' }
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          disabled: name.length <= 0,
          label: EnvironmentManager.getMessageText({ key: 'button_save_uc' }) || 'KAYDET',
          onClick: () => {
            onPrimaryClick(name);
          },
        }
      } }>
      <Message type="none">
        <div
          className="tjk-save-coupon-success-modal-input">
          <Input
            title={ EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_coupon_saved_give_name' }) || 'Kuponuna İsim Ver' }
            id='name'
            value={ name || '' }
            type='text'
            autoComplete='off'
            maxLength={ 15 }
            onChange={ e=>{
              const { value } = e.target;
              setName(value.replace(/^\s+/, ''));
            } }
            clearInput={ ()=>{
              setName('');
            } }
            validateOnBlur
            onBlur={ e=>{
              const { value } = e.target;
              if (value.trim() !== '') {
                setName(value);
              }
            } }
          />
        </div>
      </Message>
    </Modal>
  );
};

CouponRenameModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon rename failure modal
export const CouponRenameFailureModal = props => {
  const { modalClose } = props;

  return (
    <Modal
      title={ EnvironmentManager.getMessageText({ key: 'title_tjk_coupon_unsaved_give_name' }) || 'Kuponuna İsim Verilemedi' }
      type={ 'error' }
      iconName="svgInfoRed"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KAPAT',
          onClick: () => {
            modalClose();
          },
        }
      } }>
      <Message type="none">
        <span>
         Kupon ismi kaydedilemedi. Lütfen daha sonra tekrar deneyiniz.
        </span>
      </Message>
    </Modal>
  );
};

CouponRenameFailureModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// coupon ids copy modal
export const CouponIdsCopyModal = props => {
  const { modalClose, modalData: { tjkCouponIdsCopyModal } } = props;
  const showToast = (type, message, toastId) => {
    toast(<ToastTemplate type={ type }>{ message }</ToastTemplate>, { toastId });
  };
  return (
    <Modal
      title="Kupon Oynama"
      type={ 'success' }
      iconName="svgInfoGreen"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KAPAT',
          onClick: () => {
            modalClose();
          }
        }
      } }
    >
      <Message type="none">
        <div className='couponids-copy-modal__text'>Kupon oynanma saati: { tjkCouponIdsCopyModal.playDate }</div>
        { tjkCouponIdsCopyModal.couponIds?.map((id, index) => (
          <div key={ index } className='couponids-copy-modal'><span className='couponids-copy-modal__title'>Kupon No:</span>{ id }<Icon iconName="svgCopy" onClick={ () => {
            tjkCouponIdsCopyModal.triggerMixpanel();
            copyToClipboard(id, () => showToast('success', 'Kupon numarası kopyalandı.', 'toastCouponIdCopy'));
          }
          } /></div>
        )) }
      </Message>
    </Modal>
  );
};

CouponIdsCopyModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

// NotAvaliableFeatureModal modal ( At kartı ve koşu kartı için )
export const NotAvaliableFeatureModal = props => {
  const { modalClose } = props;

  return (
    <Modal
      title="Uyarı"
      type={ 'error' }
      iconName="svgInfoRed"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KAPAT',
          onClick: () => {
            modalClose();
          },
        }
      } }>
      <Message type="none">
        <span>
          { EnvironmentManager.getMessageText({ key: 'description_tjk_leaderform_not_available' }) || 'Şu an için bu hizmet verilmemektedir.' }
        </span>
      </Message>
    </Modal>
  );
};

NotAvaliableFeatureModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

